module.exports = __webpack_public_path__ + "static/media/netflix.a1f673e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/netflix.png
// module id = 1485
// module chunks = 0